import React from "react";
import {
    Button,
    convertInputFormToObject,
    InputForm,
    inputStyles, SelectField,
    TextField,
    useInputForm
} from "../../../../Components/Inputs";
import {clearInputFormFields} from "../../../../Components/Inputs/inputUtility";
import {gridConstants, GridContainer, GridCell} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";
import {isRmtcAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";
import {createListFromArray, createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {ownLoanHistorySearchModel} from "./ownLoanHistorySearchFactory";
import {OWN_LOAN_HISTORY_STATUS_LIST} from "../LoanManagement/ownLoanConstants";

interface OwnLoanHistorySearchFormViewProps {
    ownLoanHistorySearchCriteria: Record<string, any>;
    ownLoanSearchDropDowns: Record<string, any>;
    handleSetOwnLoanHistorySearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
}

export const OwnLoanHistorySearchFormView = ({
                                                 ownLoanHistorySearchCriteria,
                                                 ownLoanSearchDropDowns,
                                                 handleSetOwnLoanHistorySearchCriteria,
                                                 isLoading,
                                             }: OwnLoanHistorySearchFormViewProps) => {

    const patrons = createListFromArrayOfObjects(ownLoanSearchDropDowns?.patrons, "userId", "fullName");
    const shippingLocations = createListFromArrayOfObjects(ownLoanSearchDropDowns?.shippingLocations, "shippingLocationId", "name");
    const districts = createListFromArrayOfObjects(ownLoanSearchDropDowns?.districts, "districtId", "districtName");
    const organizations = createListFromArray(ownLoanSearchDropDowns?.organizations);

    const ownLoanHistorySearchForm = useInputForm(ownLoanHistorySearchModel());

    const handleClearClick = () => {
        clearInputFormFields(ownLoanHistorySearchForm);
        const updatedLoanHistorySearchCriteria = {...ownLoanHistorySearchCriteria};
        updatedLoanHistorySearchCriteria.ClearLoanHistorySearch();
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(ownLoanHistorySearchForm);
        const updatedLoanHistorySearchCriteria = {...ownLoanHistorySearchCriteria};
        updatedLoanHistorySearchCriteria.Search(criteria);
        handleSetOwnLoanHistorySearchCriteria(updatedLoanHistorySearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.THREE,
    };

    return <>
        <InputForm name={"loanHistorySearch"} hasPaddingY>
            {
                isRmtcAdmin() &&
                <SearchableSingleSelectField
                    {...ownLoanHistorySearchForm.patronId}
                    {...inputSharedSettings}
                    includeDefaultOption
                    label={'Patron'}
                    options={patrons}
                />
            }

            <TextField
                {...ownLoanHistorySearchForm.ownCatalogTitle}
                {...inputSharedSettings}
            />

            <SearchableSingleSelectField
                {...ownLoanHistorySearchForm.shippingLocationId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Shipping Locations'}
                options={shippingLocations}
            />

            <SelectField
                {...ownLoanHistorySearchForm.ownLoanStatus}
                {...inputSharedSettings}
                defaultOptionValue={""}
                defaultOption={"All"}
                includeDefaultOption
                label={"Own Request Status"}
                options={OWN_LOAN_HISTORY_STATUS_LIST}
            />

            {
                isRmtcAdmin() &&
                <>
                    <SearchableSingleSelectField
                        {...ownLoanHistorySearchForm.districtId}
                        {...inputSharedSettings}
                        includeDefaultOption
                        label={'District'}
                        options={districts}
                    />
                    <SearchableSingleSelectField
                        {...ownLoanHistorySearchForm.organization}
                        {...inputSharedSettings}
                        includeDefaultOption
                        options={organizations}
                    />
                </>

            }

            <GridCell>
                <GridContainer hasPaddingX isFlush isReverseOrder>
                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            label="Search"
                            name="btnSearchLoan"
                            onClick={handleSearchClick}
                            isPrimary
                        />
                    </GridCell>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            name="btnClearLoanSearch"
                            onClick={handleClearClick}
                            label="Clear"
                        />
                    </GridCell>

                </GridContainer>
            </GridCell>

        </InputForm>
    </>
};
